import { Typography } from "@material-ui/core";
import * as React from "react";
import styled from "styled-components";

const StyledText = styled(Typography)`
  font-size: 18px;
  padding-bottom: 16px;

  a {
    color: inherit;
    text-decoration: none;
  }
`;

export function Copyright() {
  return (
    <StyledText color="textSecondary" align="center">
      {"©Business Logic - "}
      <a href="https://www.blogic.cz/">www.blogic.cz</a>
    </StyledText>
  );
}
